import React from 'react';
import { InstagramAccount } from '../../types';
import { translations } from '../../translations';

interface CloseFriendsProps {
  account: InstagramAccount;
  isDarkMode: boolean;
  language: string;
}

export function CloseFriends({ account, isDarkMode, language }: CloseFriendsProps) {
  const t = translations[language as keyof typeof translations];

  return (
    <div className={`p-6 rounded-lg border ${
      isDarkMode 
        ? 'bg-[#1c1c1c] border-[#2b2b2b]' 
        : 'bg-white border-[#e5e7eb]'
    }`}>
      <div className="flex items-center gap-3">
        <div className="relative">
          <div className="w-3 h-3 bg-emerald-500 rounded-full">
            <div className="absolute inset-0 bg-emerald-500 rounded-full animate-ping opacity-75"></div>
          </div>
        </div>
        <p className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
          {t.close_friends_active}
        </p>
      </div>
      
      <div className="mt-6">
        <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
          {t.close_friends_description}
        </p>
      </div>
    </div>
  );
}